import * as React from 'react';

type CircularLoaderProps = React.SVGProps<SVGSVGElement> & {
  size?: number;
  durationMs?: number;
  color?: string;
  opacity?: string;
};

export function CircularLoader({
  size = 36,
  durationMs = 900,
  color = '0, 0, 0',
  opacity = '0.4',
  ...props
}: CircularLoaderProps) {
  const id = React.useId();

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <defs>
        <radialGradient
          id={`angular-${id}-outer`}
          cx="18"
          cy="18"
          r="10"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor={`rgba(${color}, 0.0001)`} />
          <stop offset="100%" stopColor={`rgba(${color}, ${opacity})`} />
        </radialGradient>
        <radialGradient
          id={`angular-${id}-inner`}
          cx="18"
          cy="18"
          r="10"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor={`rgba(${color}, 0.0001)`} />
          <stop offset="100%" stopColor={`rgba(${color}, ${opacity})`} />
        </radialGradient>
      </defs>

      {/* Outer ring */}
      <g>
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 18 18"
          to="360 18 18"
          dur={`${durationMs}ms`}
          repeatCount="indefinite"
        />
        <path
          d="M28 18C28 23.5228 23.5228 28 18 28C12.4772 28 8 23.5228 8 18C8 12.4772 12.4772 8 18 8C23.5228 8 28 12.4772 28 18ZM11.5 18C11.5 21.5898 14.4101 24.5 18 24.5C21.5898 24.5 24.5 21.5898 24.5 18C24.5 14.4101 21.5898 11.5 18 11.5C14.4101 11.5 11.5 14.4101 11.5 18Z"
          fill={`url(#angular-${id}-outer)`}
          opacity="0.7"
        />
      </g>

      {/* Quarter arc */}
      <g>
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 18 18"
          to="-360 18 18"
          dur={`${durationMs * 1.5}ms`}
          repeatCount="indefinite"
        />
        <path
          d="M18 8C19.3132 8 20.6136 8.25866 21.8268 8.76121C23.0401 9.26375 24.1425 10.0003 25.0711 10.9289C25.9997 11.8575 26.7362 12.9599 27.2388 14.1732C27.7413 15.3864 28 16.6868 28 18L24.5 18C24.5 17.1464 24.3319 16.3012 24.0052 15.5126C23.6786 14.7239 23.1998 14.0074 22.5962 13.4038C21.9926 12.8002 21.2761 12.3214 20.4874 11.9948C19.6988 11.6681 18.8536 11.5 18 11.5L18 8Z"
          fill={`url(#angular-${id}-inner)`}
          opacity="0.7"
        />
      </g>
    </svg>
  );
}
